// eslint-disable-next-line tree-shaking/no-side-effects-in-initialization
import gql from 'graphql-tag'

const DATES_QUERY = /*#__PURE__*/ gql`
  query searchRates($args: RateInput, $published: Boolean) {
    searchRates(args: $args, published: $published) {
      publishedFrom
    }
  }`

export {DATES_QUERY}
